import { render, staticRenderFns } from "./ModalFormTest.vue?vue&type=template&id=9ac236a4&"
import script from "./ModalFormTest.vue?vue&type=script&lang=js&"
export * from "./ModalFormTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports